import { useQueryAttributeMappings } from '../../schema/mappings/mappingsActions';
import DataLoadingErrorFallback from '../../common/errors/DataLoadingErrorFallback';
import { SalvProgressCircle } from '@salvapp/ui-components';
import { getAttributeMappingFieldName } from '../../common/helper';
import { ApiAttributeMappingFieldEnum } from '../../api';
import { Direction } from '../../common/attributes/types';
import React from 'react';

interface CounterpartyProps {
  attributes: { [key: string]: string };
}

export const Counterparty = ({ attributes }: CounterpartyProps) => {
  const {
    data: attributeMappings,
    isPending: isAttributeMappingsPending,
    isError: isAttributeMappingsError,
  } = useQueryAttributeMappings();

  if (isAttributeMappingsError) {
    return <DataLoadingErrorFallback message={'Could not load Attribute Mappings'} />;
  } else if (isAttributeMappingsPending) {
    return <SalvProgressCircle ariaLabel={'Loading Attribute Mappings'} />;
  }

  const direction = attributes[
    getAttributeMappingFieldName(ApiAttributeMappingFieldEnum.CREDIT, attributeMappings.map)
  ] as Direction;

  switch (direction) {
    case 'I':
      return (
        <>
          <div>
            {attributes[getAttributeMappingFieldName(ApiAttributeMappingFieldEnum.FROM_NAME, attributeMappings.map)]}
          </div>
          <div className='account'>
            {attributes[getAttributeMappingFieldName(ApiAttributeMappingFieldEnum.FROM_ACCOUNT, attributeMappings.map)]}
          </div>
        </>
      );
    case 'O':
      return (
        <>
          <div>
            {attributes[getAttributeMappingFieldName(ApiAttributeMappingFieldEnum.TO_NAME, attributeMappings.map)]}
          </div>
          <div className='account'>
            {attributes[getAttributeMappingFieldName(ApiAttributeMappingFieldEnum.TO_ACCOUNT, attributeMappings.map)]}
          </div>
        </>
      );
    case undefined:
      return '-';
  }
};
